/**
 * @generated by Icons/generate-icons.ts — do not edit by hand.
 * Source: svg/QwickSpark.svg. Edit that .svg (or svg/icons.config.json) and run
 * `pnpm --filter @gigpro/ui generate:icons`.
 */
import type { IconComponent } from "./types";

export const QwickSpark: IconComponent = ({ ref, color = "currentColor", ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="5.75 5.75 12.5 12.75" ref={ref} {...props}>
    <path
      fill={color}
      d="M17.975 12.538c-4.123.507-5.17 1.554-5.677 5.677-.043.353-.553.353-.596 0-.507-4.123-1.554-5.17-5.677-5.677-.353-.043-.353-.553 0-.596 4.123-.507 5.17-1.554 5.677-5.677.043-.353.553-.353.596 0 .507 4.123 1.554 5.17 5.677 5.677.353.043.353.553 0 .596"
    />
  </svg>
);
QwickSpark.displayName = "QwickSpark";
